import { render, staticRenderFns } from "./taskBrokerage.vue?vue&type=template&id=67a02f2e&scoped=true"
import script from "./taskBrokerage.vue?vue&type=script&lang=js"
export * from "./taskBrokerage.vue?vue&type=script&lang=js"
import style0 from "./taskBrokerage.vue?vue&type=style&index=0&id=67a02f2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a02f2e",
  null
  
)

export default component.exports